module.exports = __webpack_public_path__ + "img/26_51.678c09b5.png";